/**
 * Shared API client singleton for the web SPA.
 *
 * All React code should import { api } from '@/lib/apiClient' instead of
 * instantiating its own client — keeps the bearer token store consistent
 * and makes it trivial to swap to a Capacitor-backed store in the mobile
 * shell (just hand a different `tokenStore` to `createApiClient`).
 */
import {
  createApiClient,
  createLocalStorageTokenStore,
  type ApiClient,
} from '@draftedge/api-client';

// Vite proxies `/v2/*` → http://localhost:8080 in dev. In production both the
// SPA and Laravel are served from the same origin, so a relative baseUrl is
// correct in every environment we currently target.
//
// For Capacitor (file:// origin in WebView) we'll override this in the mobile
// shell with the deployed API origin (e.g. https://api.draftedge.com).
const baseUrl = '/v2';

export const api: ApiClient = createApiClient({
  baseUrl,
  tokenStore: createLocalStorageTokenStore(),
  onUnauthorized: () => {
    // The Zustand auth store imports this module and listens for token
    // clearing via `bootstrap()` retrying — but proactively dispatch an event
    // so any subscribed UI can react immediately.
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('draftedge:unauthorized'));
    }
  },
});
